/** @format */

import { Action, createReducer, on } from '@ngrx/store';
import { setCommonData, setCommonDsgVhHeader, setCommonPageType } from './common.actions';

import { CommonPageType } from '@shared/data-access/common';
import { chain } from '@core/chain';

export interface CommonState {
  // dick's sporting goods
  chainAbbr: string;
  chainName: string;
  dsgVh: string;
  pageType: CommonPageType | '';
}

const initCommonState: CommonState = {
  chainName: '',
  chainAbbr: '',
  dsgVh: '',
  pageType: '',
};

export const commonReducers = createReducer(
  initCommonState,
  on(setCommonData, (state) => ({
    ...state,
    chainName: chain.chainName,
    chainAbbr: chain.chainIdentifierAbbr,
    dsgVh: chain.chainIdentifierCookie ?? '',
  })),
  on(setCommonDsgVhHeader, (state, action) => ({
    ...state,
    dsgVh: action.dsgVh,
  })),
  on(setCommonPageType, (state, action) => ({
    ...state,
    pageType: action.pageType,
  })),
);

// export for module import
export function commonReducer(state: CommonState | undefined, action: Action): CommonState {
  return commonReducers(state, action);
}
